var compareProductsObj;
var flashingInProgress;

document.addEventListener("DOMContentLoaded", function() {
    compareProductsObj = new CompareProducts();

    isComparePage = location.href.includes('/pages/compare-products');

    if (isComparePage)
    {
        compareProductsObj.runComparePage();
    }
    else 
    {
        compareProductsObj.runNonComparePage();
    }
});


class CompareProducts
{
    container;
    compareProductHandles = [];
    table;
    products = [];

    constructor()
    {
        var compareHandles = this.getCompareProductIdsFromStorage();
        this.compareProductHandles = compareHandles != null ? compareHandles : [];
    }

    getCompareProductIdsFromStorage()
    {
        var compareProductIdsFromStorage = localStorage.getItem('compare_product_handles');
        return JSON.parse(compareProductIdsFromStorage);
    }

    async runNonComparePage()
    {
        this.showGoToComparePopup();
    }

    async showGoToComparePopup()
    {
        var popup = document.getElementById('compare-products-go-to');
        var countContainer = popup.querySelector('#compare_from_count');
        var count = this.compareProductHandles != null ? this.compareProductHandles.length : 0;
        if (count > 0)
        {
            popup.style.display = 'block';
            countContainer.innerHTML = count;
        }
    }

    async runComparePage()
    {
        this.setUpContainer("compare-products");        
        this.showLoading();
        this.products = await this.fetchProducts();
        if (this.products.length == 0)
        {
            return this.showNoProductsMessage();
        }
        this.makeTable();
        this.populateTable();
    }

    setUpContainer(containerId)
    {
        this.container = document.getElementById(containerId);
        if (this.container == null)
        {
            return alert("ERROR: NO_CONTAINER. Sorry! Something has gone wrong. Cannot display compare products right now.")
        }
    }

    showNoProductsMessage()
    {
        this.container.innerHTML = 
        `
            <p>
                You have no products selected to compare. Please go to a collection and select some products to compare.
            </p>
        `
    }

    showLoading()
    {
        this.container.innerHTML = 
        `
            <p>
                One moment please while we compare your products...
            </p>
        `
    }

    makeTable()
    {
        this.container.innerHTML = '';
        this.table = document.createElement("table");
        this.table.style.width = '100%';
        this.container.append(this.table);
    }

    populateTable()
    {
        // image row
        var row_image = document.createElement('tr');
        var context = this;
        this.products.forEach(function(product) {
            var col = document.createElement('td');
            col.style.position = 'relative';
            var img = document.createElement('img');
            img.src = product.featured_image;
            img.style.maxWidth = '300px';
            img.style.width = '100%';
            img.style.display = 'block';
            img.style.margin = '0 auto';

            // delete button
            var btn = document.createElement('button');
            btn.textContent = 'X';
            btn.type = 'button';
            btn.style.position = 'absolute';
            btn.style.right = '0px';
            btn.style.top = '0px';
            btn.style.background = '#ede8e8';
            btn.style.color = '#7e6d6d';
            btn.style.cursor = 'pointer';
            btn.style.fontSize = '18pt';
            btn.style.margin = '10px';
            btn.style.border = 'none';
            btn.style.borderRadius = '50%';
            btn.style.padding = '4px 10px';
            btn.onclick = (e, m) => {
                context.removeProductToCompareFromComparePage(product.handle);
            }

            col.appendChild(img);
            col.appendChild(btn);
            row_image.appendChild(col);
        });

        // product title row
        var row_productTitle = document.createElement('tr');
        this.products.forEach(function(product) {
            var col = document.createElement('td');
            col.textContent = product.title;
            col.style.fontWeight = 'bold';
            col.style.textAlign = 'center';
            col.style.fontSize = '1.6rem';
            row_productTitle.appendChild(col);
        });

        // product price row
        var row_price = document.createElement('tr');
        this.products.forEach(function(product) {
            var col = document.createElement('td');
            col.textContent = `£${(product.price / 100).toFixed(2)}`;
            col.style.fontWeight = 'bold';
            col.style.textAlign = 'center';
            col.style.fontSize = '1.8rem';
            row_price.appendChild(col);
        });

        // add to cart row
        var row_addToCart = document.createElement('tr');
        this.products.forEach(function(product) {
            var col = document.createElement('td');
            col.innerHTML += `
                <button type="button" 
                        class="button button--primary button--full-width"
                        style="min-width: 100px; padding: 5px"
                        onclick="compareProductsObj.addToCart(${product.variants[0].id}, 1)">
                    Add to cart
                </a>
            `;
            row_addToCart.appendChild(col);
        });

        // product description row
        var row_productDescription = document.createElement('tr');
        this.products.forEach(function(product) {
            var col = document.createElement('td');
            col.style.verticalAlign = 'top';

            var contentOutter = document.createElement('div');

            var content = document.createElement('div');
            content.id = `compare_product_${product.id}`;
            content.style.maxHeight = '400px';
            content.textContent = product.description;
            content.style.overflow = 'hidden';
            contentOutter.appendChild(content);

            contentOutter.innerHTML += `
                <button class="readMoreToggleButton button button--secondary button--full-width" 
                    style="min-width: 100px; padding: 5px; background: white; font-size: 11pt; margin-top: 20px"
                    onclick="compareProductsObj.toggleReadMoreCompareDescription(this)" 
                    data-current-state="text_hidden"
                    data-content-id="${content.id}">
                    Read More...
                </button>
            `;

            col.appendChild(contentOutter);
            row_productDescription.appendChild(col);
        });

        // add each row to the table
        this.table.appendChild(row_image);
        this.table.appendChild(row_productTitle);
        this.table.appendChild(row_price);
        this.table.appendChild(row_addToCart);
        this.table.appendChild(row_productDescription);
    }

    async fetchProducts()
    {
        var products = [];
        // limit to 3 iterations
        var iterations = this.compareProductHandles.length > 3 ? 3 : this.compareProductHandles.length;
        for (let i = 0; i < iterations; i++) {
            const productId = this.compareProductHandles[i];
            try {
                const response = await fetch(`/products/${productId}.js`);
                const responseJson = await response.json();
                products.push(responseJson);
            } catch (error) {
                console.error(`Failed to fetch product ${productId}:`, error);
                // Remove the product from compareProductHandles array
                this.compareProductHandles.splice(i, 1);
                // Decrement the index because we removed the element from the array
                i--;
                // remove by hanlde
                this.removeFromLocalStorage(this.compareProductHandles[i]);
            }
        }
        return products;
    }

    toggleReadMoreCompareDescription(button)
    {
        var currentState = button.dataset.currentState;
        var contentId = button.dataset.contentId;

        var container = document.getElementById(contentId);

        switch (currentState)
        {
          // text hidden - now show full text
          case 'text_hidden':
            container.style.maxHeight = 'initial';
            button.dataset.currentState = 'text_shown';
            button.innerHTML = 'Read Less';
          break;
          // text shown = now hide full text
          case 'text_shown':
            container.style.maxHeight = '400px';
            button.dataset.currentState = 'text_hidden';
            button.innerHTML = 'Read More';
          break;
          
        }
    }

    addToCart(variantId, quantity)
    {
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: variantId,  // The variant ID, not the product ID
                quantity: quantity
            }),
        })
        .then(response => response.json())
        .then(data => {
            if (data.id > 0)
            {
                location.href = '/cart';
                return;
            }
        })
        .catch(error => {
            alert("Sorry! Unable to add to cart due to unkown error.");
        });
    }

    async addProductToCompare(productHandle)
    {
        if (this.compareProductHandles != null && this.compareProductHandles.length == 3)
        {
            return alert("You already have 3 products to compare, the maximum number of products to compare is 3.");
        }

        this.compareProductHandles.push(productHandle);
        localStorage.setItem('compare_product_handles', JSON.stringify(this.compareProductHandles));
        this.compareProductHandles = this.getCompareProductIdsFromStorage(); 
        await compareProductsObj.showGoToComparePopup();

        // flash the popup
        this.flashComparePopup();
    }

    async removeProductToCompareFromComparePage(productHandle)
    {
        this.removeFromLocalStorage(productHandle);
        this.runComparePage();
    }

    async removeProductToCompare(productHandle)
    {
        this.removeFromLocalStorage(productHandle);
    }

    async removeFromLocalStorage(productHandle)
    {
        this.compareProductHandles = this.getCompareProductIdsFromStorage(); 
        var index = this.compareProductHandles.indexOf(productHandle);
        this.compareProductHandles.splice(index, 1);
        localStorage.setItem('compare_product_handles', JSON.stringify(this.compareProductHandles));
    }

    flashComparePopup()
    {
        console.log(flashingInProgress);
        if (flashingInProgress != null && flashingInProgress == true)
        {
            return; 
        }

        var popup = document.getElementById('compare-products-go-to');
        var flashIntervalId = setInterval(function(){
            flashingInProgress = true;
            if (popup.classList.contains('flash'))
            {
                popup.classList.remove('flash');
            }
            else
            {
                popup.classList.add('flash');
            }
        }, 500)

        // Set a timeout to stop the interval after 5 seconds
        setTimeout(function() {
            clearInterval(flashIntervalId); // Stop the flashing
            flashingInProgress = false;
        }, 5000); // 5000 milliseconds = 5 seconds
    }
}